import { forwardRef } from "react";
import { CustomContentProps, MaterialDesignContent, useSnackbar } from "notistack";

/** notistack's stock toast, closed by a click anywhere on it unless it persists, because a persisted toast is
 * closed by whatever raised it. The wrapper takes the transition's ref and style because MaterialDesignContent
 * does not pass an onClick through. */
const DismissOnClickContent = forwardRef<HTMLDivElement, CustomContentProps>(function DismissOnClickContent({ style, ...props }, ref) {
  const { closeSnackbar } = useSnackbar();

  if (props.persist) return <MaterialDesignContent ref={ref} {...props} style={style} />;

  return (
    <div ref={ref} style={style} className="cursor-pointer" onClick={() => closeSnackbar(props.id)}>
      <MaterialDesignContent {...props} style={{}} />
    </div>
  );
});

export const DISMISS_ON_CLICK_COMPONENTS = {
  default: DismissOnClickContent,
  success: DismissOnClickContent,
  error: DismissOnClickContent,
  warning: DismissOnClickContent,
  info: DismissOnClickContent,
};
